/*
 * Class providing custom ornament glass rule. Rule is checking chosen options and returning true or false.
 */
class OrnamentGlassRuleService {
    constructor() {
        this.temperedGlassType = 2;
        this.laminated33SafetyType = 3;
        this.laminated44SafetyType = 4;
    }

    checkIfLaminatedOrSafetyGlassOnInside(insideGlass) {
        return (insideGlass.attributes.glassSafetyId === this.temperedGlassType ||
            insideGlass.attributes.glassSafetyId === this.laminated33SafetyType ||
            insideGlass.attributes.glassSafetyId === this.laminated44SafetyType);
    }

    checkIfOrnamentOnInside(ornament) {
        return !ornament.attributes.default;
    }
}

export default angular.module('ornamentGlassRuleService', [])
    .service('ornamentGlassRuleService', OrnamentGlassRuleService)
    .name;
